<div class="w9-agent-header">
  <div class="w9-agent-header__left">
    <div class="w9-agent-header__avatar"><sm-sonder-avatar [size]="20" /></div>
    <div>
      <div class="w9-agent-header__title">Sonder</div>
      <div class="w9-agent-header__subtitle">Your AI assistant</div>
    </div>
  </div>
  <div class="w9-agent-header__right">
    <button
      type="button"
      class="w9-agent-header__tab"
      [class.w9-agent-header__tab--active]="activeTab === 'chat'"
      data-tab="chat"
      aria-label="Chat"
      (click)="onTab('chat')"
    >
      <iris-icon name="chat_outline" [size]="iconSizes.SM"></iris-icon>
    </button>
    <button
      type="button"
      class="w9-agent-header__tab"
      [class.w9-agent-header__tab--active]="activeTab === 'tasks'"
      data-tab="tasks"
      aria-label="Tasks"
      (click)="onTab('tasks')"
    >
      <iris-icon name="task_alt" [size]="iconSizes.SM"></iris-icon>
    </button>
  </div>
</div>
